import { createRoot } from 'react-dom/client';
import * as React from "react";
import BookGame from "./src/BookGame";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<BookGame />);
